import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const isLoggedIn = localStorage.getItem('jwt') 
  // const isLoggedIn =  true
  return isLoggedIn ? <Outlet /> : <Navigate to="/quiz" />;
};

export default PrivateRoute;
